import _slicedToArray from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// ignore-string-externalization
import React from 'react';
import { useBannerState } from './BannerState';
import { Banner } from './Banner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Banners = function Banners() {
  var _useBannerState = useBannerState(),
      _useBannerState2 = _slicedToArray(_useBannerState, 1),
      state = _useBannerState2[0];

  return /*#__PURE__*/_jsx(_Fragment, {
    children: state.banners.map(function (singleBannerState) {
      return /*#__PURE__*/_jsx(Banner, {
        singleBannerState: singleBannerState
      }, singleBannerState.id);
    })
  });
};